module.exports = __webpack_public_path__ + "static/media/information-green-icon.e5abf19c.svg";